import React from "react";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import Proposed from "../../utils/images/propose.jpg";
import styled from "styled-components";
const Layout = styled.div`
  font-family: "Oswald", sans-serif;
  .circle {
    border: 1px solid #fff;
    height: 120px;
    width: 120px;
    border-radius: 50%;
    font-size: 40px;
    color: #fff;
    display: grid;
    place-items: center;
  }
  .title {
    font-size: 40px;
    font-weight: 400;
    color: #fff;
  }
  .desc {
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    padding-top: 20px;
    text-align: center;
  }
`;
function StoryBanner() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <span className="circle">
            <HeartFilled />
          </span>
          <h1 className="title">HE Proposed </h1>
          <div>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
          </div>

          <div className="desc">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt Ut enim ad minim veniam, quis nostrud
          </div>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(0deg,rgba(125,50,210,0.5),rgba(200,170,110,0.5)),url(${Proposed})`,
    height: 530,
    backgroundSize: "cover",
    objectFit: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "Center",
    alignItems: "center",
    padding: 40,
  },
};
export default StoryBanner;
